import React, { useEffect } from 'react'
import HeaderReturn from '../../../../components.js/serveur/siteWeb/HeaderReturn'
import useFirebase from '../../../../firebase/useFirebase'
import useForm from './../../../../hooks/useForm'
import { useNavigate } from 'react-router-dom'

const INITIAL_STATE = {
    nomEntreprise:'',
    uid:'',
    email:'',
    adresse:'',
    telephoneEntreprise:'',
    telephoneSalon:'',
    siret:'',
    forfait:'',
    icon:'',
    qrcodeAndroid:'',
    qrcodeApple:'',
}

const CreateAccountAdministrateur = () => {
    const { handleChange, values, refresh } = useForm(INITIAL_STATE)
    const { writeData, updateData } = useFirebase()
    let navigate = useNavigate()

    useEffect(() => {
        window.scrollTo(0, 0)
    },[])

    const _createAccount = () => {
        const data = {
            nomEntreprise:values.nomEntreprise,
            uid:values.uid,
            email:values.email,
            adresse:values.adresse,
            telephoneEntreprise:values.telephoneEntreprise,
            telephoneSalon:values.telephoneSalon,
            siret:values.siret,
            forfait:values.forfait,
            icon:values.icon,
            qrcodeAndroid:values.qrcodeAndroid,
            qrcodeApple:values.qrcodeApple
        }
        updateData('entreprises/'+values.uid+'/profil',data)
        refresh()
        navigate('/entreprises')
    }

    return (
        <div className='container-fluid'>
            <HeaderReturn  title='Nouveau compte' link='/administrateur'/>
            <div>
            {/* NOM ENTREPRISE */}
            <div className='mt-3'>
                <input type="text" className='form-control' values={values.nomEntreprise} name='nomEntreprise' onChange={handleChange} placeholder='nom entreprise' />
            </div>
            {/* UID */}
            <div className='mt-3'>
                <input type="text" className='form-control' values={values.uid} name='uid' onChange={handleChange} placeholder='uid' />
            </div>
            {/* EMAIL */}
            <div className='mt-3'>
                <input type="email" className='form-control' values={values.email} name='email' onChange={handleChange} placeholder='email' />
            </div>
            {/* ADRESSE */}
            <div className='mt-3'>
                <textarea type="text" rows="4" className='form-control' values={values.adresse} name='adresse' onChange={handleChange} placeholder='adresse' />
            </div>
            {/* TELEPHONE ENTREPRISE */}
            <div className='mt-3'>
                <input type="text" className='form-control' values={values.telephoneEntreprise} name='telephoneEntreprise' onChange={handleChange} placeholder='telephone entreprise' />
            </div>
            {/* TELEPHONE SALON */}
            <div className='mt-3'>
                <input type="text" className='form-control' values={values.telephoneSalon} name='telephoneSalon' onChange={handleChange} placeholder='telephone salon' />
            </div>
            {/* SIRET */}
            <div className='mt-3'>
                <input type="text" className='form-control' values={values.siret} name='siret' onChange={handleChange} placeholder='siret' />
            </div>
            {/* FORFAIT */}
            <div className='mt-3'>
                <input type="text" className='form-control' values={values.forfait} name='forfait' onChange={handleChange} placeholder='forfait' />
            </div>
            {/* ICON */}
            <div className='mt-3'>
                <input type="text" className='form-control' values={values.icon} name='icon' onChange={handleChange} placeholder='icon' />
            </div>
            {/* QRCODE ANDROID */}
            <div className='mt-3'>
                <input type="text" className='form-control' values={values.qrcodeAndroid} name='qrcodeAndroid' onChange={handleChange} placeholder='qrcode android' />
            </div>
            {/* QRCODE APPLE */}
            <div className='mt-3'>
                <input type="text" className='form-control' values={values.qrcodeApple} name='qrcodeApple' onChange={handleChange} placeholder='qrcode apple' />
            </div>
            </div>
            <div className='text-center'> 
                <button 
                    className='btn btn-outline-dark mt-3'
                    disabled={
                        values.nomEntreprise &&
                        values.uid &&
                        values.email &&
                        values.adresse &&
                        values.telephoneEntreprise &&
                        values.telephoneSalon &&
                        values.siret &&
                        values.forfait &&
                        values.icon &&
                        values.qrcodeAndroid &&
                        values.qrcodeApple ? false : true
                    }
                    onClick={_createAccount}
                >créer le compte</button>
            </div>
            <div style={{ height:400 }} />
        </div>
    )
}

export default CreateAccountAdministrateur


